import client from '../../../graphql/apollo-client';
import { FetchSegmentsPayload, SegmentsResponse } from '../types';
import {
  LoadingStates,
  OTS_SEGMENT_MANAGER_DEFAULT_PLATFORM,
  RateLevel,
} from '../../../constants';
import { OTS_SGM_MNG_FAILED_TO_FETCH_SEGMENTS } from '../../../content';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  addNotification,
  fetchSegments,
  setSegments,
  setSegmentsLoading,
} from '../slice';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getGraphQLEndpointByPlatform,
  getGraphQLQueryByPlatform,
} from '../utils/utils';

// Default rate level for segment list (system-level segments only)
const DEFAULT_RATE_LEVEL = RateLevel.SYSTEM;

function* handleFetchSegments(
  action: PayloadAction<FetchSegmentsPayload>
): Generator<any, void, any> {
  try {
    yield put(setSegmentsLoading({ state: LoadingStates.LOADING }));

    const payload = action.payload || {};
    const platform = payload.platform || OTS_SEGMENT_MANAGER_DEFAULT_PLATFORM;
    const variables: Record<string, any> = {
      platform: platform,
      rateLevel: DEFAULT_RATE_LEVEL,
      page: payload.page || 1,
      recordPerPage: payload.recordPerPage || 25,
    };

    if (payload.sortBy) variables.sortBy = payload.sortBy;
    if (payload.sortOrder) variables.sortOrder = payload.sortOrder;
    if (
      payload.search !== undefined &&
      payload.search !== null &&
      payload.search !== ''
    )
      variables.search = payload.search;
    if (platform) variables.platform = platform;
    if (payload.page) variables.page = payload.page;
    if (payload.recordPerPage) variables.recordPerPage = payload.recordPerPage;

    const result = yield call([client, client.query], {
      query: getGraphQLQueryByPlatform(platform),
      variables: variables,
      fetchPolicy: 'network-only',
    });

    // Get the platform-specific endpoint name
    const endpointName = getGraphQLEndpointByPlatform(platform);

    // Access the response data based on platform
    const segmentsResponse: SegmentsResponse = result.data?.[endpointName] || {
      lastSyncAt: '',
      totalRecords: 0,
      segments: [],
    };

    yield put(setSegments(segmentsResponse));
    yield put(setSegmentsLoading({ state: LoadingStates.DONE }));
  } catch (e: any) {
    console.error('Error fetching segments:', e);
    yield put(setSegmentsLoading({ state: LoadingStates.ERROR }));
    yield put(
      addNotification({
        state: LoadingStates.ERROR,
        message: OTS_SGM_MNG_FAILED_TO_FETCH_SEGMENTS,
      })
    );
  }
}

export default function* watchAll() {
  yield takeLatest(fetchSegments.type, handleFetchSegments);
}
